import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Notas } from '../../../models/models';
import { FirebaseRequestsService } from '../../../services/requests/firebase/firebase-requests.service';

@Component({
  selector: 'app-lembretes',
  templateUrl: './lembretes.component.html',
  styleUrls: ['./lembretes.component.scss'],
})
export class LembretesComponent implements OnInit, OnDestroy {
  clientesDoVendedorComLembretes!: Notas[];
  documentsAmount = 10;
  startAt = 0;
  private subscriptions: Subscription[] = [];

  constructor(public fireReqs: FirebaseRequestsService) {}

  ngOnInit(): void {
    const subscription = this.fireReqs
      .getClientesDoVendedorComLembretes('', this.documentsAmount)
      .subscribe((clientes) => {
        this.clientesDoVendedorComLembretes = clientes;
      });
    this.subscriptions.push(subscription);
  }

  getMoreClientes() {
    if (this.clientesDoVendedorComLembretes.length === 0) return; // Avoid errors

    const lastClient =
      this.clientesDoVendedorComLembretes[
        this.clientesDoVendedorComLembretes.length - 1
      ];

    const clientesSubscription = this.fireReqs
      .getClientesDoVendedorComLembretes(lastClient, this.documentsAmount)
      .subscribe((clientes) => {
        if (clientes.length > 0) {
          this.clientesDoVendedorComLembretes = [
            ...this.clientesDoVendedorComLembretes,
            ...clientes,
          ];
        }
      });

    this.subscriptions.push(clientesSubscription);
  }

  onScroll() {
    console.log('scrolled!');
    this.getMoreClientes();
  }

  deleteCliente(clienteCpf: string, clienteSiglaMarca: string) {
    const clienteIndex = this.clientesDoVendedorComLembretes.findIndex(
      (cliente) =>
        cliente.cpf === clienteCpf && clienteSiglaMarca === cliente.sigla_marca
    );

    this.clientesDoVendedorComLembretes.splice(clienteIndex, 1);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
